import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type AuthLoadErrorProps = {
  /** Repeats the user-info request that determines the authentication state. */
  onRetry: () => void;
  /** Optionally permits a route-specific fallback despite unresolved authentication. */
  onContinue?: () => void;
};

/** Presents a reusable authentication-check failure without imposing route layout. */
export const AuthLoadError: React.FC<AuthLoadErrorProps> = ({ onRetry, onContinue }) => (
  <Alert
    severity="error"
    role="alert"
    action={
      <Stack direction="row" spacing={1}>
        <Button color="inherit" size="small" onClick={onRetry}>
          Retry
        </Button>
        {onContinue && (
          <Button color="inherit" size="small" onClick={onContinue}>
            Continue to login
          </Button>
        )}
      </Stack>
    }
  >
    <Typography component="span" variant="body2">
      We couldn’t check your sign-in status.
    </Typography>
  </Alert>
);
